export default {
  owned: '已拥有',

  gem_prestigeStone: {
    name: '声望石',
    description: '获得等同于你最佳周期的声望货币'
  },
  mining_goldenHammer: {
    name: '金锤',
    description: '获得此制作可能的最佳镐'
  },
  village_ingredientBox: {
    name: '配料盒',
    description: '包含随机配料的盒子，可以用于制作特殊物品'
  },
  horde_manaPotion: {
    name: '法力药水',
    description: '补充50%的最大法力值'
  },
  farm_basic: {
    name: '基础肥料',
    description: '提供基础的营养，适合所有作物'
  },
  farm_flower: {
    name: '花肥',
    description: '专为花卉设计的特殊肥料，能促进花朵更好地生长'
  },
  farm_speedGrow: {
    name: '快速生长剂',
    description: '加速作物生长进程，减少收获等待时间'
  },
  farm_richSoil: {
    name: '肥沃土壤',
    description: '极其肥沃的土壤，能显著提高作物产量'
  },
  farm_shiny: {
    name: '闪亮肥料',
    description: '使作物闪闪发光，增加稀有掉落几率'
  },
  farm_juicy: {
    name: '多汁肥料',
    description: '使作物更加多汁，增加产量'
  },
  farm_dissolving: {
    name: '作物溶解剂',
    description: '快速溶解作物，立即收获但可能减少产量'
  },
  farm_potatoWater: {
    name: '土豆水',
    description: ''
  },
  farm_roseWater: {
    name: '玫瑰水',
    description: ''
  },
  farm_weedKiller: {
    name: '除草剂',
    description: ''
  },
  farm_turboGrow: {
    name: '涡轮生长',
    description: ''
  },
  farm_premium: {
    name: '优质肥料',
    description: ''
  },
  farm_analyzing: {
    name: '分析肥料',
    description: ''
  },
  farm_superJuicy: {
    name: '超级多汁',
    description: ''
  },
  farm_pellets: {
    name: '颗粒',
    description: ''
  },
  farm_sunshine: {
    name: '阳光',
    description: ''
  },
  farm_superFlower: {
    name: '超级鲜花',
    description: ''
  },
  farm_smellyMud: {
    name: '臭泥',
    description: ''
  },
  farm_tropicalWater: {
    name: '热带水',
    description: ''
  },
  farm_fieldBlessing: {
    name: '田野祝福',
    description: ''
  },
  farm_cinnamonBag: {
    name: '肉桂袋',
    description: ''
  },
};